<docs>
# Confirm

> NOTE: this docs defined at **docs** section inside Confirm.vue module

Confirm UI Set

<!-- STORY -->

### Example

>warning

```html
<template>
  <mt-button @click="warningConfirm">Click to Warning button</mt-button>
</template>

<script>
export default {
  methods: {
    warningConfirm(){
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
      .then(() => {
        // fire when click Confirm button
      })
      .catch(() => {
        // fire when click Cancel button
      })
    }
  }
}
</script>
```

>success

```html
<template>
  <mt-button @click="successConfirm">Click to Success button</mt-button>
</template>

<script>
export default {
  methods: {
    successConfirm(){
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'success'
      })
      .then(() => {
        // fire when click Confirm button
      })
      .catch(() => {
        // fire when click Cancel button
      })
    }
  }
}
</script>
```

>error

```html
<template>
  <mt-button @click="errorConfirm">Click to Error button</mt-button>
</template>

<script>
export default {
  methods: {
    errorConfirm(){
      this.$mtConfirm(`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard`, 'Title', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'error'
      })
      .then(() => {
        // fire when click Confirm button
      })
      .catch(() => {
        // fire when click Cancel button
      })
    }
  }
}
</script>
```
### Props

| Property      | Description           | Type           | Accepted Values       | Default     |
|---------------|-----------------------|----------------|-----------------------|-------------|
| closeVisible  | closeVisible of item  | Boolean        | —                     | false       |

</docs>
<template>
<transition name="confirm-fade">
  <div class="mt-confirm mt-zindex--topest"
    v-if="visible" @click.self="handleWrapperClick"
    :class="['mt-modal--small',type]">
    <div class="mt-confirm__dialog">
      <header class="mt-confirm__header">
        <mt-icon :iconName="iconName" :hover="'not-set'" :color="iconColor" />
        <span>{{title}}</span>
      </header>
      <div class="mt-confirm__body">
        {{message}}
      </div>
      <div class="mt-confirm__footer">
        <button class="mt-button mt-button--primary mt-button--small" @click="handleAction('confirm')">{{confirmButtonText}}</button>
        <button class="mt-button mt-button--subtle mt-button--small"  @click="handleAction('cancel')">{{cancelButtonText}}</button>
      </div>
    </div>
  </div>
</transition>
</template>
<script>
import MtButton from '../button/Button.vue'
import MtIcon from '../icon/Icon.vue'

export default {
  name: 'mt-confirm',
  props: {
    closeVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    MtButton,
    MtIcon,
  },

  data () {
    return {
      action: '',
      visible: false,
      title: '',
      type: '',
      message: '',
      confirmButtonText: '',
      cancelButtonText: '',
    }
  },

  computed: {
    iconName() {
      if(this.type == 'error') return 'error-circle'
      if(this.type == 'warning') return 'warning-circle'
      if(this.type == 'success') return 'check-circle'
    },
    iconColor() {
      if(this.type == 'error') return '#f44336'
      if(this.type == 'warning') return '#FFC107'
      if(this.type == 'success') return '#00c853'
    },
  },

  methods: {
    handleWrapperClick(){
      this.visible = false;
    },
    handleAction(action) {
      this.action = action;
      this.doClose();
    },
    doClose() {
      if (!this.visible) return;
      this.visible = false;
      setTimeout(() => {
        if (this.action) this.callback(this.action, this);
      });
    },
  },

  mounted () {
	},

  watch: {
  },
}
</script>
<style src="./Confirm.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Confirm.vue?87fadca8